"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var event_1 = require("../../util/event");
exports.EVENT_MAP = event_1.EVENT_MAP;
exports.onEvent = event_1.onEvent;
var SHAPE_EVENT_MAP = {
    onRingProgressClick: 'interval:click',
    onRingProgressDblclick: 'interval:dblclick',
    onRingProgressMousemove: 'interval:mousemove',
    onRingProgressMousedown: 'interval:mousedown',
    onRingProgressMouseup: 'interval:mouseup',
    onRingProgressMouseenter: 'interval:mouseenter',
    onRingProgressMouseleave: 'interval:mouseleave',
    onRingProgressContextmenu: 'interval:contextmenu',
};
_.assign(event_1.EVENT_MAP, SHAPE_EVENT_MAP);
//# sourceMappingURL=event.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/sparkline/ring-progress/event.js
// module id = 1008
// module chunks = 37